import { memo, useCallback } from "react";
import { KycLandingPageStatus, ErrorPageContent } from "@ploy-ui/core";
import { useFetcher } from "@rest-hooks/core";
import { SectionProps } from "../Section";

import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { useAppLoad } from "../../appLoadContext";
import { ErrorHandler } from "@ploy-lib/core";
import { LandingPageStatusesResource } from "@ploy-lib/rest-resources";

addRegisteredSectionLayout({
	name: "KycLandingPageStatusSection",
	displayName: "KycLandingPageStatusSection",
	settings: {}
});

const KycLandingPageStatusSectionInternal = memo((props: SectionProps) => {
	const {
		className,
		onClick,
		setSectionCompleted,
		formTemplateSectionId,
		hideSignerList,
		hideSignerEditing,
		showAlternativeMessage
	} = props;

	const { applicationId } = useAppLoad();

	const refetchLandingPageStatus = useFetcher(
		LandingPageStatusesResource.list()
	);

	const refetchStatus = useCallback(() => {
		refetchLandingPageStatus({ applicationId });
	}, [refetchLandingPageStatus]);

	return (
		<KycLandingPageStatus
			applicationId={applicationId}
			className={className}
			externalPostback={refetchStatus}
		/>
	);
});

const KycLandingPageStatusSection = (props: SectionProps) => (
	<ErrorHandler
		fallback={e => (
			<ErrorPageContent
				className={props.className}
				onClick={props.onClick}
				header={
					<span>
						{KycLandingPageStatusSection.displayName} failed to render.
					</span>
				}
			/>
		)}
	>
		<KycLandingPageStatusSectionInternal {...props} />
	</ErrorHandler>
);

KycLandingPageStatusSection.displayName = "DployKycLandingPageStatusSection";

export { KycLandingPageStatusSection };
